/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import { is_breakpoint_up, make_url } from "../helpers/functions";
import Swiper from "./../libs/swiper";

function initFiltersTypesEvents() {
  let $filters = $(".filter");
  if (!$filters.length) {
    return;
  }

  $filters
    .find(".filter-type-checkbox .filter-type-container")
    .each(function () {
      let $el = $(this);

      let filterSwiper = $el[0].swiper;

      if (is_breakpoint_up("xl")) {
        if (filterSwiper) {
          filterSwiper.destroy();
        }
      } else {
        if (!filterSwiper) {
          filterSwiper = new Swiper($el[0], {
            slidesPerView: "auto",
            freeMode: true,
          });
        }
      }
    });
}

function initFiltersEvents() {
  let $filters = $(".filter");
  if (!$filters.length) {
    return;
  }

  initFiltersTypesEvents();
  $(window).resize(function () {
    initFiltersTypesEvents();
  });
}

$(function () {
  $(document).on("click.filter-event", ".filter-toggle", function (e) {
    let $opener = $(this);
    let $container = $opener.closest(".filter-container");
    if (!$container.length) {
      $container = $opener.parent();
    }
    let $filter = $container.find(".filter");

    if (!$filter.length) {
      return;
    }

    $container.toggleClass("filter-open");

    let $opened = $container.hasClass("filter-open");

    if ($opened) {
      let $searchInput = $filter.find(".filter-checkbox-search input");
      if ($searchInput.length) {
        $searchInput.focus();
      }

      $(".filter-container.filter-open")
        .not($container)
        .removeClass("filter-open");

      $filter.trigger("open.filter");
    } else {
      $filter.trigger("close.filter");
    }

    e.stopPropagation();
  });

  $(document).on("click.filter-event", function (e) {
    let $filtersOpened = $(".filter-container.filter-open");
    if (!$filtersOpened.length) {
      return;
    }

    if (
      $(e.target).hasClass("filter-toggle") ||
      $(e.target).closest(".filter-toggle").length
    ) {
      return;
    }

    if ($(e.target).closest(".filter").length === 0) {
      $filtersOpened.removeClass("filter-open");

      $filtersOpened.find(".filter").trigger("close.filter");
    }
  });

  $(document).on("close.filter", ".filter", function () {
    let $container = $(this).closest(".filter-container");
    if (is_breakpoint_up("xl")) {
      $container.closest("form").submit();
      return;
    }

    let toUncheck = $(this).find('input:checked[data-checked="0"]');
    let toCheck = $(this).find('input:not(:checked)[data-checked="1"]');

    toUncheck.prop("checked", false);
    toCheck.prop("checked", true);
  });

  $(document).on(
    "change.filter",
    '.filter .filter-type-checkbox .filter-checkbox input[type="checkbox"], .filter .filter-type-button .btn-group input[type="radio"]',
    function () {
      let $container = $(this).closest(".filter-container");

      if (
        $(this).attr("name").indexOf("body_type") !== -1 &&
        $(this).val() === "back" &&
        $(this).is(":checked")
      ) {
        let path = $.address.pathNames().slice(1);
        path.shift();
        $.address.autoUpdate(false);
        $.address.path(make_url(path.join("/")));
        $.address.parameter("body_type", "");
        window.location.href = $.address.value();
        return false;
      }

      if (!$(this).closest(".filter").find(".filter-footer").is(":visible")) {
        $container.closest("form").submit();
      }
    },
  );

  $(document).on("open.filter", ".filter", function () {
    let $filter = $(this);
    let $container = $(this).closest(".filter-container");

    if ($filter.hasClass("filter-full-width")) {
      let $widthContainer = $filter.closest(
        ".container-wrapper, .container-wrapper-full",
      );
      if ($widthContainer.length) {
        $filter.css("width", $widthContainer.width());
      }
    }

    $filter
      .find(".filter-cancel")
      .off()
      .click(function () {
        $container.removeClass("filter-open");
      });

    $filter
      .find(".filter-accept")
      .off()
      .click(function () {
        $container.removeClass("filter-open");

        $container.closest("form").submit();
      });

    let $filterTypeCheckbox = $filter.find(".filter-type-checkbox");
    if ($filterTypeCheckbox.length) {
      let $search = $filter.find(".filter-checkbox-search");
      if ($search.length) {
        let $items = $search.closest(".filter").find("[data-search-value]");

        $search
          .find("input")
          .off()
          .keyup(function () {
            let $val = $(this).val();

            $items.each(function () {
              let $item = $(this).closest(".filter-checkbox-item");
              let $matched =
                $(this)
                  .data("search-value")
                  .toLowerCase()
                  .indexOf($val.toLowerCase()) !== -1;
              $matched ? $item.show() : $item.hide();
            });
          });
      }
    }
  });

  initFiltersEvents();
});

export default initFiltersTypesEvents;
